import { Box, Fab } from "@mui/material";
import React from "react";
import { useProjectContext } from "../context";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";

export const ProjectTopBanner = ({ enquiryOperationsParam, buttonType }) => {
  const { setCurrentOperationPage } = useProjectContext();
  return (
    <>
      <Box component="section" flex={1} textAlign={"right"}>
        {buttonType === "back" ? (
          <Fab
            color="primary"
            size="small"
            aria-label="Back"
            onClick={() => setCurrentOperationPage(enquiryOperationsParam)}
          >
            <ArrowBackIcon />
          </Fab>
        ) : (
          <Fab
            color="primary"
            size="small"
            aria-label="Add"
            onClick={() => setCurrentOperationPage(enquiryOperationsParam)}
          >
            <AddIcon />
          </Fab>
        )}
      </Box>
      <ToolbarThinWrapper />
    </>
  );
};
